import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Header from "../components/Header";
import { Box } from "@material-ui/core";
import PatientStatus from "../components/PatientStatus";
import { makeStyles } from "@material-ui/core/styles";
import { cndWrapperURL, sdkWrapperURL } from "../Util/ApiAxios";
import Loader from "react-loader-spinner";
import axios from "axios";

const CreateSlots = () => {
  const classes = useStyles();
  const [isLoading, setLoading] = React.useState(false);
  const [infoCND, setInfoCND] = React.useState({ token: "", id: "" });

  useEffect(() => {
    let Token = localStorage.getItem("dhct_Token");
    setLoading(true);
    let data = {
      platform_name: "DHCT",
      response_platform_name: "CARENOWDOC",
    };
    axios
      .post(sdkWrapperURL("/auth/refresh-token"), data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: Token,
        },
      })
      .then((resp) => {
        if (resp.data.statusCode === 200) {
          setInfoCND({ token: resp.data.token, id: resp.data.id });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  }, []);
  return (
    <div>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}

      <Header />
      <Box className={classes.Pagecontent}>
        <Box className={classes.Leftcol}>
          <Box className={classes.leftnav} style={{ marginTop: "40px" }}>
            {localStorage.getItem("dhct_JWT") ? <PatientStatus /> : <></>}
          </Box>
        </Box>
        <Box className={classes.Rightcol}>
          {isLoading ? (
            <Loader
              type="ThreeDots"
              color="#114ebd"
              height={75}
              width={75}
              timeout={0}
              className={classes.loader}
            />
          ) : (
            <>
              <iframe
                src={cndWrapperURL(
                  `/clinic/slot-redirect?${new URLSearchParams({
                    id: infoCND.id,
                    token: infoCND.token,
                  }).toString()}`
                )}
                sandbox="allow-same-origin allow-scripts allow-forms"
                title="Create Appointments"
                width="100%"
                height="100%"
                style={{
                  border: "none",
                  overflow: "hidden",
                  minHeight: "100vh",
                }}
                allowFullScreen
              />
            </>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default CreateSlots;
const useStyles = makeStyles(() => ({
  Pagecontent: {
    width: "100%",
    display: "flex",
    textAlign: "left",
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  Leftcol: {
    width: "15%",
    padding: "20px 3%",
    position: "relative",
    minHeight: "800px",
    background: "linear-gradient(45deg, #114ebd, #0f3d6e)",
    "@media only screen and (max-width: 1200px)": {
      width: "24%",
      padding: "20px 1%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "98%",
      padding: "20px 1%",
      position: "absolute",
      background: "none",
      minHeight: 25,
    },
    "@media only screen and (max-width: 768px)": {
      width: "98%",
      padding: "20px 1%",
      position: "absolute",
      background: "none",
      minHeight: 25,
    },
  },
  Rightcol: {
    width: "75%",
    padding: "20px 2%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minWidth: "33%",
    },
    "& .MuiTab-root:nth-child(6)": {
      minWidth: "30%",
    },
    "& .MuiTab-root:nth-child(7)": {
      minWidth: "30%",
    },
  },
}));
